"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.TableContext = void 0;
exports.TableProvider = TableProvider;
exports.useTableContext = useTableContext;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var TableContext = /*#__PURE__*/_react.default.createContext();
/**
 * A context provider that supplies data to all subcomponents of Table
 */


exports.TableContext = TableContext;

function TableProvider(_ref) {
  var rowSelectionEnabled = _ref.rowSelectionEnabled,
      selectedRowIds = _ref.selectedRowIds,
      onSelectionUpdated = _ref.onSelectionUpdated,
      globalSelection = _ref.globalSelection,
      registerRowData = _ref.registerRowData,
      tableLayout = _ref.tableLayout,
      children = _ref.children;
  var value = {
    rowSelectionEnabled: rowSelectionEnabled,
    selectedRowIds: selectedRowIds,
    onSelectionUpdated: onSelectionUpdated,
    registerRowData: registerRowData,
    globalSelection: globalSelection,
    tableLayout: tableLayout
  };
  return /*#__PURE__*/_react.default.createElement(TableContext.Provider, {
    value: value
  }, children);
}

function useTableContext() {
  var context = _react.default.useContext(TableContext); // TODO removed this for now; TableToolbar can exist both inside and outside
  // the table component, so we have to allow this to be called when table
  // context is not available
  // if (context === undefined) {
  //     throw new Error('useTableContext must be used within a TableProvider');
  // }


  return context;
}

TableProvider.propTypes = {
  rowSelectionEnabled: _propTypes.default.bool,
  selectedRowIds: _propTypes.default.object,
  onSelectionUpdated: _propTypes.default.func,
  globalSelection: _propTypes.default.string,
  registerRowData: _propTypes.default.func,
  tableLayout: _propTypes.default.object,
  children: _propTypes.default.node
};
TableProvider.ROW_SELECTION_ALL = 'ALL';
TableProvider.ROW_SELECTION_NONE = 'NONE';
TableProvider.ROW_SELECTION_SOME = 'SOME';
TableProvider.ROW_SELECTION_SELECTED = 'SELECTED';
TableProvider.ROW_SELECTION_UNSELECTED = 'UNSELECTED';